var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useCallback, useContext, useEffect, useMemo, useState, useRef, } from "react";
import cloneDeep from "lodash/cloneDeep";
import { AuthNFlowClient, AuthFlow, } from "@pangeacyber/vanilla-js";
import { STORAGE_DEVICE_ID_KEY, STORAGE_REMEMBER_USERNAME_KEY, } from "@pangeacyber/react-mui-authn";
import { setCookie, getCookie } from "@src/utils";
import { FlowPhase } from "./types";
var SESSION_DATA_NAME = "flow-session";
var SESSION_RELOAD = "flow-session-reload";
var COOKIE_NO_PASSKEY = "no-passkey-prompt";
export var AuthFlowContext = createContext({});
export var AuthFlowProvider = function (_a) {
    var config = _a.config, options = _a.options, children = _a.children;
    var _b = useState(""), phase = _b[0], setPhase = _b[1];
    var _c = useState(), error = _c[0], setError = _c[1];
    var _d = useState(true), loading = _d[0], setLoading = _d[1];
    var _e = useState(), data = _e[0], setData = _e[1];
    var _f = useState(), cbParams = _f[0], setCbParams = _f[1];
    var isStart = useRef(true);
    var useEmail = useRef(false);
    var usedPasskey = useRef(false);
    var invite = useRef(false);
    var captchaCode = useRef("");
    // @ts-ignore
    var isPangea = window.IS_PANGEA || false;
    var client = useMemo(function () {
        return new AuthNFlowClient(config, options);
    }, []);
    useEffect(function () {
        var _a;
        // use email with start call if passed as a param
        var urlParams = new URLSearchParams(window.location.search);
        var emailParam = urlParams.get("email") || "";
        var navEntries = (_a = window === null || window === void 0 ? void 0 : window.performance) === null || _a === void 0 ? void 0 : _a.getEntriesByType("navigation");
        // if back button is used, clear the session and reload - PAN-15224
        if (navEntries &&
            // @ts-ignore
            String(navEntries[0].type) === "back_forward") {
            deleteSessionCookie();
            deleteSessionData();
            location.reload();
        }
        if (emailParam.match(/^[A-Za-z0-9_%'+`~.-]+@[A-Za-z0-9.-]+$/gm)) {
            useEmail.current = true;
            start({ email: emailParam });
        }
        else if (!!(config === null || config === void 0 ? void 0 : config.email)) {
            start({ email: config === null || config === void 0 ? void 0 : config.email });
        }
        else {
            start({});
        }
    }, []);
    var getSessionData = function () {
        var storedData = localStorage.getItem(getSessionKeyName());
        if (storedData) {
            var session = JSON.parse(storedData);
            return session;
        }
        return {};
    };
    var updateSessionData = useCallback(function (phase, data) {
        var sessionData = getSessionData();
        var newData = __assign(__assign({}, sessionData), { flow_id: data.flowId, format: data.usernameFormat, phase: phase, invite: invite.current, callbackState: __assign({}, data.callbackStateMap) });
        var dataString = JSON.stringify(newData);
        localStorage.setItem(getSessionKeyName(), dataString);
    }, [data === null || data === void 0 ? void 0 : data.phase]);
    var deleteSessionData = function () {
        localStorage.removeItem(getSessionKeyName());
    };
    var setReloadTime = function () {
        var data = { last: Math.floor(Date.now() / 1000) };
        sessionStorage.setItem(SESSION_RELOAD, JSON.stringify(data));
    };
    var checkShouldReload = function () {
        var ts = sessionStorage.getItem(SESSION_RELOAD);
        if (ts) {
            var data_1 = JSON.parse(ts);
            var now = Math.floor(Date.now() / 1000);
            return data_1.last < now - 10;
        }
        return true;
    };
    var deleteSessionCookie = function () {
        document.cookie = "__hosted_session2=; samesite=strict; ;expires=Thu, 01 Jan 1970 00:00:01 GMT; secure";
    };
    var start = function (payload) { return __awaiter(void 0, void 0, void 0, function () {
        var sessionData, queryString, urlParams, cbState, cbCode, cbFlowId, redirect, flowId, providerData, socialName, payload_1, _a, success, response, samlData, providerId, providerName, payload_2, _b, success, response, deviceId, username, utmCodes, _c, success, response;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    sessionData = getSessionData();
                    if (!!(config === null || config === void 0 ? void 0 : config.email) || !!sessionData.invite) {
                        invite.current = true;
                    }
                    queryString = window.location.search;
                    urlParams = new URLSearchParams(queryString);
                    cbState = urlParams.get("state") || "";
                    cbCode = urlParams.get("code") || "";
                    cbFlowId = urlParams.get("flow") || "";
                    redirect = urlParams.get("redirect_uri") || "";
                    flowId = config.flowId || sessionData.flow_id;
                    if (cbState && cbCode) {
                        setCbParams({ state: cbState, code: cbCode });
                    }
                    else if (cbState && redirect) {
                        sessionStorage.setItem("redirect", JSON.stringify({ redirect: redirect, state: cbState }));
                    }
                    if (!(flowId && !useEmail.current)) return [3 /*break*/, 8];
                    // continue the flow, unless an email is in the url params
                    client.initState({
                        flowId: flowId,
                        phase: sessionData.phase,
                    });
                    if (!(!!cbFlowId && cbFlowId !== sessionData.flow_id)) return [3 /*break*/, 1];
                    setPhase(FlowPhase.FLOW_RETURN);
                    return [3 /*break*/, 7];
                case 1:
                    if (!(cbCode &&
                        sessionData.callbackState &&
                        sessionData.callbackState[cbState])) return [3 /*break*/, 6];
                    providerData = sessionData.callbackState[cbState];
                    setLoading(true);
                    if (!providerData.startsWith("social:")) return [3 /*break*/, 3];
                    socialName = providerData.replace("social:", "");
                    payload_1 = {
                        social_provider: socialName,
                        uri: window.location.toString(),
                    };
                    return [4 /*yield*/, client.verifySocial(payload_1)];
                case 2:
                    _a = _d.sent(), success = _a.success, response = _a.response;
                    updateFlowState(success, response);
                    return [3 /*break*/, 5];
                case 3:
                    if (!providerData.startsWith("saml:")) return [3 /*break*/, 5];
                    samlData = providerData.replace("saml:", "");
                    providerId = samlData.split(":", 1)[0];
                    providerName = samlData.replace("".concat(providerId, ":"), "");
                    payload_2 = {
                        provider_id: providerId,
                        provider_name: providerName,
                        uri: window.location.toString(),
                    };
                    return [4 /*yield*/, client.verifySaml(payload_2)];
                case 4:
                    _b = _d.sent(), success = _b.success, response = _b.response;
                    updateFlowState(success, response);
                    _d.label = 5;
                case 5:
                    setLoading(false);
                    return [3 /*break*/, 7];
                case 6:
                    getState();
                    _d.label = 7;
                case 7: return [3 /*break*/, 10];
                case 8:
                    setLoading(true);
                    deviceId = localStorage.getItem(STORAGE_DEVICE_ID_KEY);
                    if (deviceId) {
                        payload.device_id = deviceId;
                    }
                    username = localStorage.getItem(STORAGE_REMEMBER_USERNAME_KEY);
                    if (username) {
                        payload.email = username;
                    }
                    if (config.clientId) {
                        payload.client_id = config.clientId;
                    }
                    // TODO: add scope and oauth_* vars to config and start payload
                    // @ts-ignore -
                    if (config.scope) {
                        // @ts-ignore
                        payload.scope = config.scope;
                    }
                    // @ts-ignore
                    if (config.oauth2Nonce) {
                        // @ts-ignore
                        payload.oauth2_nonce = config.oauth2Nonce;
                    }
                    // @ts-ignore
                    if (config.oauth2CodeChallenge) {
                        // @ts-ignore
                        payload.oauth2_code_challenge = config.oauth2CodeChallenge;
                    }
                    // @ts-ignore
                    if (config.oauth2CodeChallengeMethod) {
                        // @ts-ignore
                        payload.oauth2_code_challenge_method = config.oauth2CodeChallengeMethod;
                    }
                    // @ts-ignore
                    if (config.oauth2State) {
                        // @ts-ignore
                        payload.oauth2_state = config.oauth2State;
                    }
                    // @ts-ignore
                    if (config.oauth2ResponseTypes) {
                        // @ts-ignore
                        payload.oauth2_response_types = config.oauth2ResponseTypes;
                    }
                    // @ts-ignore
                    if (config.oauth2RedirectUrl) {
                        // @ts-ignore
                        payload.oauth2_redirect_uri = config.oauth2RedirectUrl;
                    }
                    // ---- end TODO
                    // send signup tracking data for Pangea
                    if (isPangea) {
                        utmCodes = getCookie("pangea-utm-code");
                        if (!!utmCodes) {
                            // @ts-ignore
                            payload.utm_codes = utmCodes;
                        }
                    }
                    return [4 /*yield*/, client.start(payload)];
                case 9:
                    _c = _d.sent(), success = _c.success, response = _c.response;
                    updateFlowState(success, response);
                    setLoading(false);
                    isStart.current = false;
                    _d.label = 10;
                case 10: return [2 /*return*/];
            }
        });
    }); };
    var getState = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _a, success, response, sessionData, newUrl;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    setLoading(true);
                    return [4 /*yield*/, client.getFlowState()];
                case 1:
                    _a = _b.sent(), success = _a.success, response = _a.response;
                    if (!success && (response === null || response === void 0 ? void 0 : response.status) === "InvalidFlow") {
                        // rebuild the URL if left in a state with the /component/callback path
                        if (window.location.pathname.startsWith("/component")) {
                            sessionData = JSON.parse(sessionStorage.getItem("redirect") || "");
                            if (sessionData) {
                                newUrl = "".concat(window.location.protocol, "//").concat(window.location.host, "/authorize?redirect_uri=").concat(sessionData.redirect, "&state=").concat(sessionData.state);
                                window.history.replaceState({}, document.title, newUrl);
                            }
                            deleteSessionCookie();
                            deleteSessionData();
                            location.reload();
                        }
                        else {
                            reset();
                        }
                    }
                    else {
                        updateFlowState(success, response);
                    }
                    setLoading(false);
                    return [2 /*return*/];
            }
        });
    }); };
    var getSessionKeyName = function () {
        return "".concat(SESSION_DATA_NAME, "-").concat((data === null || data === void 0 ? void 0 : data.phase) === "phase_one_time" ? "onetime" : "auth");
    };
    var restart = useCallback(function (choice, data) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, success, response;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    setLoading(true);
                    return [4 /*yield*/, client.restart(choice, data)];
                case 1:
                    _a = _b.sent(), success = _a.success, response = _a.response;
                    updateFlowState(success, response);
                    setLoading(false);
                    return [2 /*return*/];
            }
        });
    }); }, [client]);
    var reset = useCallback(function () {
        // remove the 'flow' parameter if it's set and update the URL
        var urlParams = new URLSearchParams(window.location.search);
        if (urlParams.get("flow")) {
            urlParams.delete("flow");
            var newUrl = "".concat(window.location.protocol, "//").concat(window.location.host).concat(window.location.pathname, "?").concat(urlParams.toString());
            window.history.replaceState({}, document.title, newUrl);
        }
        deleteSessionData();
        client.reset();
        start({});
    }, [client]);
    var update = useCallback(function (step, payload, extra) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            setLoading(true);
            usedPasskey.current = false;
            switch (step) {
                case AuthFlow.Choice.NONE:
                    getState();
                    break;
                case AuthFlow.Choice.SET_EMAIL:
                    setEmailHandler(payload);
                    break;
                case AuthFlow.Choice.SET_USERNAME:
                    setUsernameHandler(payload);
                    break;
                case AuthFlow.Choice.SET_PHONE:
                    setPhoneHandler(payload);
                    break;
                case AuthFlow.Choice.PASSWORD:
                    verifyPasswordHandler(payload, extra);
                    break;
                case AuthFlow.Choice.SET_PASSWORD:
                    setPasswordHandler(payload);
                    break;
                case AuthFlow.Choice.CAPTCHA:
                    captchaHandler(payload);
                    break;
                case AuthFlow.Choice.PROFILE:
                    profileHandler(payload);
                    break;
                case AuthFlow.Choice.VERIFY_EMAIL:
                    verifyEmailHandler();
                    break;
                case AuthFlow.Choice.SOCIAL:
                    verifySocial(payload);
                    break;
                case AuthFlow.Choice.SAML:
                    verifySaml(payload);
                    break;
                case AuthFlow.Choice.EMAIL_OTP:
                    verifyEmailOtp(payload);
                    break;
                case AuthFlow.Choice.SMS_OTP:
                    verifySmsOtp(payload);
                    break;
                case AuthFlow.Choice.TOTP:
                    verifyTotp(payload);
                    break;
                case AuthFlow.Choice.AGREEMENTS:
                    acceptAgreement(payload);
                    break;
                case AuthFlow.Choice.RESET_PASSWORD:
                    resetPassword();
                    break;
                case AuthFlow.Choice.PASSKEY:
                    sendPasskey(payload);
                    break;
                case AuthFlow.Choice.CONSENT:
                    oauthConsent(payload);
                    break;
                case AuthFlow.Choice.COMPLETE:
                    completeFlow(payload);
                    break;
                default:
                    // invalid state
                    console.log("Invalid Flow State", step);
            }
            setLoading(false);
            return [2 /*return*/];
        });
    }); }, [client]);
    var setEmailHandler = function (payload) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, success, response;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, client.setEmail(payload)];
                case 1:
                    _a = _b.sent(), success = _a.success, response = _a.response;
                    updateFlowState(success, response);
                    return [2 /*return*/];
            }
        });
    }); };
    var setUsernameHandler = function (payload) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, success, response;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, client.setUsername(payload)];
                case 1:
                    _a = _b.sent(), success = _a.success, response = _a.response;
                    updateFlowState(success, response);
                    return [2 /*return*/];
            }
        });
    }); };
    var setPhoneHandler = function (payload) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, success, response;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, client.setPhone(payload)];
                case 1:
                    _a = _b.sent(), success = _a.success, response = _a.response;
                    updateFlowState(success, response);
                    return [2 /*return*/];
            }
        });
    }); };
    var verifyPasswordHandler = function (payload, extra) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, success, response, _b, success_1, response_1;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    if (extra) {
                        captchaCode.current = extra;
                    }
                    return [4 /*yield*/, client.verifyPassword(payload)];
                case 1:
                    _a = _c.sent(), success = _a.success, response = _a.response;
                    if (!(success && captchaCode.current)) return [3 /*break*/, 3];
                    return [4 /*yield*/, client.verifyCaptcha({
                            code: captchaCode.current,
                        })];
                case 2:
                    _b = _c.sent(), success_1 = _b.success, response_1 = _b.response;
                    updateFlowState(success_1, response_1);
                    return [3 /*break*/, 4];
                case 3:
                    updateFlowState(success, response);
                    _c.label = 4;
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var setPasswordHandler = function (payload) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, success, response;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, client.setPassword(payload)];
                case 1:
                    _a = _b.sent(), success = _a.success, response = _a.response;
                    updateFlowState(success, response);
                    return [2 /*return*/];
            }
        });
    }); };
    var captchaHandler = function (payload) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, success, response;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, client.verifyCaptcha(payload)];
                case 1:
                    _a = _b.sent(), success = _a.success, response = _a.response;
                    updateFlowState(success, response);
                    return [2 /*return*/];
            }
        });
    }); };
    var profileHandler = function (payload) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, success, response;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, client.updateProfile(payload)];
                case 1:
                    _a = _b.sent(), success = _a.success, response = _a.response;
                    updateFlowState(success, response);
                    return [2 /*return*/];
            }
        });
    }); };
    var verifyEmailHandler = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _a, success, response;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, client.verifyEmail()];
                case 1:
                    _a = _b.sent(), success = _a.success, response = _a.response;
                    updateFlowState(success, response);
                    return [2 /*return*/];
            }
        });
    }); };
    var verifySocial = function (payload) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, success, response;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, client.verifySocial(payload)];
                case 1:
                    _a = _b.sent(), success = _a.success, response = _a.response;
                    updateFlowState(success, response);
                    return [2 /*return*/];
            }
        });
    }); };
    var verifySaml = function (payload) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, success, response;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, client.verifySaml(payload)];
                case 1:
                    _a = _b.sent(), success = _a.success, response = _a.response;
                    updateFlowState(success, response);
                    return [2 /*return*/];
            }
        });
    }); };
    var verifyEmailOtp = function (payload) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, success, response;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, client.emailOtp(payload)];
                case 1:
                    _a = _b.sent(), success = _a.success, response = _a.response;
                    updateFlowState(success, response);
                    return [2 /*return*/];
            }
        });
    }); };
    var verifySmsOtp = function (payload) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, success, response;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, client.smsOtp(payload)];
                case 1:
                    _a = _b.sent(), success = _a.success, response = _a.response;
                    updateFlowState(success, response);
                    return [2 /*return*/];
            }
        });
    }); };
    var verifyTotp = function (payload) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, success, response;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, client.totp(payload)];
                case 1:
                    _a = _b.sent(), success = _a.success, response = _a.response;
                    updateFlowState(success, response);
                    return [2 /*return*/];
            }
        });
    }); };
    var acceptAgreement = function (payload) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, success, response;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, client.acceptAgreement(payload)];
                case 1:
                    _a = _b.sent(), success = _a.success, response = _a.response;
                    updateFlowState(success, response);
                    return [2 /*return*/];
            }
        });
    }); };
    var resetPassword = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _a, success, response;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, client.resetPassword()];
                case 1:
                    _a = _b.sent(), success = _a.success, response = _a.response;
                    updateFlowState(success, response);
                    return [2 /*return*/];
            }
        });
    }); };
    var sendPasskey = function (payload) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, success, response;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    usedPasskey.current = true;
                    return [4 /*yield*/, client.sendPasskey(payload)];
                case 1:
                    _a = _b.sent(), success = _a.success, response = _a.response;
                    updateFlowState(success, response);
                    return [2 /*return*/];
            }
        });
    }); };
    var oauthConsent = function (payload) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, success, response;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, client.oauthConsent(payload)];
                case 1:
                    _a = _b.sent(), success = _a.success, response = _a.response;
                    updateFlowState(success, response);
                    return [2 /*return*/];
            }
        });
    }); };
    var completeFlow = function (payload) { return __awaiter(void 0, void 0, void 0, function () {
        var nextPhase;
        return __generator(this, function (_a) {
            if (payload === null || payload === void 0 ? void 0 : payload.suppress) {
                setCookie(COOKIE_NO_PASSKEY, "1");
            }
            nextPhase = FlowPhase.COMPLETE;
            updateSessionData(nextPhase, client.state);
            setPhase(nextPhase);
            return [2 /*return*/];
        });
    }); };
    /*
      Common response utility
    */
    var updateFlowState = function (success, response) {
        var _a, _b, _c, _d;
        if (success) {
            isStart.current = false;
            setData(__assign(__assign({}, cloneDeep(client.state)), { invite: invite.current }));
            setError(undefined);
            var nextPhase = FlowPhase.INIT;
            if (client.state.complete) {
                if (!!client.state.passkey &&
                    !getCookie(COOKIE_NO_PASSKEY) &&
                    !usedPasskey.current) {
                    nextPhase = FlowPhase.PASSKEY;
                }
                else {
                    nextPhase = FlowPhase.COMPLETE;
                }
            }
            else if ((!!((_a = client.state) === null || _a === void 0 ? void 0 : _a.setEmail) || !!((_b = client.state) === null || _b === void 0 ? void 0 : _b.setUsername)) &&
                ((_c = client.state) === null || _c === void 0 ? void 0 : _c.phase) !== "phase_one_time") {
                var urlParams = new URLSearchParams(window.location.search);
                var socialParam = urlParams.get("social") || "";
                var emailParam = urlParams.get("email") || "";
                if (socialParam.match(/^[a-z_]+$/) &&
                    socialParam in client.state.socialProviderMap &&
                    !emailParam) {
                    window.location.href =
                        client.state.socialProviderMap[socialParam].redirect_uri;
                }
                {
                    nextPhase = FlowPhase.START;
                }
            }
            else if (client.state.setPassword) {
                nextPhase = FlowPhase.SET_PASSWORD;
            }
            else if (client.state.provisional) {
                nextPhase = FlowPhase.PROVISIONAL;
            }
            else if (client.state.resetPassword &&
                ((_d = client.state.resetPassword) === null || _d === void 0 ? void 0 : _d.sent)) {
                nextPhase = FlowPhase.RESET_PASSWORD;
            }
            else if (client.state.phase === "phase_profile") {
                nextPhase = FlowPhase.PROFILE;
            }
            else if (client.state.phase == "phase_captcha") {
                nextPhase = FlowPhase.CAPTCHA;
            }
            else if (client.state.phase === "phase_verify_email") {
                nextPhase = FlowPhase.VERIFY_EMAIL;
            }
            else if (client.state.phase === "phase_agreements") {
                nextPhase = FlowPhase.AGREEMENTS;
            }
            else if (client.state.phase === "phase_oauth_consent") {
                nextPhase = FlowPhase.CONSENT;
            }
            else if ((client.state.email || client.state.username) &&
                client.state.flowType.includes("signup")) {
                nextPhase = FlowPhase.SIGNUP;
            }
            else if (client.state.phase === "phase_verify_email") {
                nextPhase = FlowPhase.VERIFY_EMAIL;
            }
            else if (((client.state.email || client.state.username) &&
                client.state.flowType.includes("signin")) ||
                client.state.flowType.includes("one_time")) {
                nextPhase = FlowPhase.LOGIN;
            }
            updateSessionData(nextPhase, client.state);
            setPhase(nextPhase);
        }
        else {
            if (response.status === "Unauthorized") {
                // reload on 403, check session storage flag to prevent reload loop
                if (checkShouldReload()) {
                    setReloadTime();
                    location.reload();
                }
            }
            else if (response.status === "IncorrectAuthenticationProvider") {
                setPhase(FlowPhase.INVALID_AUTH_METHOD);
            }
            else if (response.status === "NotMatchExpectedEmail") {
                setPhase(FlowPhase.MISMATCH_EMAIL);
            }
            else if (response.status === "DisabledUser") {
                setPhase(FlowPhase.ERROR);
            }
            else if (response.status === "TravelDistanceExceeded") {
                setPhase(FlowPhase.ERROR);
            }
            else if (isStart.current) {
                setPhase(FlowPhase.ERROR);
            }
            setError(response);
        }
    };
    var memoData = useMemo(function () { return ({
        phase: phase,
        error: error,
        loading: loading,
        data: data,
        cbParams: cbParams,
        update: update,
        restart: restart,
        reset: reset,
    }); }, [phase, error, loading, data, cbParams, update, restart, reset]);
    return (_jsx(AuthFlowContext.Provider, { value: memoData, children: children }));
};
export var useAuthFlow = function () {
    return useContext(AuthFlowContext);
};
